import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatThangTuoi } from '../../../../utils/tinhThangTuoiHelper';

interface ICanNangChartProps {
    dataSource: any[]
}
Chart.register(LineElement, CategoryScale, LinearScale, PointElement);
Chart.register(ChartDataLabels);

const ChieuCaoChart = (props: ICanNangChartProps) => {
    const { dataSource } = props;
    const sortedData = [...dataSource].sort((a, b) => parseInt(a.so_thang, 10) - parseInt(b.so_thang, 10));

    const data = {
        labels: sortedData.map(x => formatThangTuoi(x.so_thang)),
        datasets: [
            {
                label: 'Chiều cao',
                data: sortedData.map(x => x.chieu_cao ?? 0),
                backgroundColor: '#4BC0C0',
                borderColor: '#4BC0C0',
                fill: false,
                tension: 0.4,
                barThickness: 25,
                maxBarThickness: 30,
            },
        ]
    };

    const options: any = {
        responsive: true,
        plugins: {
            legend: { position: 'bottom' as const, display: false },
            tooltip: { callbacks: { title: () => '', label: (context: any) => context.parsed.y } },
            title: { display: true, text: 'Biểu đồ Chiều cao' },
            datalabels: { display: false },
        },
        scales: {
            x: { title: { display: true, text: 'Tuổi', font: { size: 13, weight: 'bold' } } },
            y: { title: { display: true, text: 'Chiều cao (cm)', font: { size: 13, weight: 'bold' } }, beginAtZero: true },
        },
    };

    return <>
        <Bar data={data} options={options} />
    </>;
};

export default ChieuCaoChart;
